// extracted by mini-css-extract-plugin
export default {"word":"Word_word__IFyfj"};